<template>
  <div class="wordcloud-container">
    <div id="word-cloud"></div>
  </div>
</template>
<script>
export default {
  props: {
    scale: {
      type: Number,
      default: 1,
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.wordcloud-container {
  display: flex;
  justify-content: center;
  align-items: center;

  // styling for indivual word on the word cloud
  &::v-deep text:hover {
    text-decoration: line-through;
    cursor: pointer;
  }
}

#word-cloud {
  background: white;
}
</style>
